import {
  CALENDAR_VIEWS,
  LANGUAGE_CODES,
  PAYMENT_METHODS,
  THEMES,
} from "@fysaro/shared";
import { z } from "zod";

export const basicUserSettingsSchema = z.object({
  userName: z.string().min(3, "Nombre requerido"),
  contactEmail: z.string().email("Email inválido"),
  contactPhone: z.string().optional().nullable(),
  address: z.string().optional().nullable(),
  city: z.string().optional().nullable(),
  zipCode: z.string().optional().nullable(),
});

export const businessUserSchema = z.object({
  currency: z.string().default("EUR"), //aqui tb???
  language: z.enum(LANGUAGE_CODES).default("es"),
  preferredPaymentMethod: z.enum(PAYMENT_METHODS).default("CARD"),
  calendarView: z.enum(CALENDAR_VIEWS).default("WEEK"),
});

export const brandingUserSchema = z.object({
  avatarUrl: z.string().url().nullable().optional(),
  primaryColor: z
    .string()
    .regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)
    .nullable()
    .optional(),
  secondaryColor: z
    .string()
    .regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)
    .nullable()
    .optional(),
  backgroundColor: z
    .string()
    .regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)
    .nullable()
    .optional(),
  fontFamily: z.string().nullable().optional().default("sans"),
  borderRadius: z.coerce
    .number()
    .int()
    .min(0)
    .max(32)
    .nullable()
    .optional()
    .default(8),
  theme: z.enum(THEMES).default("light"),
  accessibilityMode: z.boolean().default(false),
  density: z.enum(["compact", "comfortable"]).default("comfortable"),
});

export const flagsUserSchema = z.object({
  allowPush: z.boolean().default(true),
  allowEmail: z.boolean().default(true),
  allowSms: z.boolean().default(true),
  allowWhatsapp: z.boolean().default(true),
  marketingNotifications: z.boolean().default(false),
  healthCommunications: z.boolean().default(false),
  appointmentReminders: z.boolean().default(false),
});

export const updateUserSettingsSchema = z.object({
  businessConf: businessUserSchema.partial().optional(), // .partial() permite modificar solo una llave del bloque
  branding: brandingUserSchema.partial().optional(),
  flags: flagsUserSchema.partial().optional(),
});
